import React, { useContext, useState } from 'react';
import Carousel1 from "../pics/BGmain1.jpg";
import { DataContext } from '../Components/DataContext';

// 1. Import Swiper React components and modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay, Pagination } from 'swiper/modules';

// 2. Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

const CarouselComponent = () => {
  const data = useContext(DataContext);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  if (!data) {
    return <div>Loading...</div>;
  }

  const { slides } = data;
  
  // Filter out blank/empty slides
  const validSlides = slides.filter(slide => 
    slide && 
    (slide.title || slide.image) && 
    slide.image && 
    slide.image.trim() !== ''
  );
  
  const handlePaginationClick = (index) => {
    if (swiperInstance) {
      swiperInstance.slideToLoop(index); // Use slideToLoop when loop is true
    }
  };

  // Don't render carousel if no valid slides
  if (!validSlides || validSlides.length === 0) {
    return null;
  }

  return (
    <div className="flex justify-center items-center w-full min-h-[calc(40vh+20px)] max-h-96 px-4">
      <div className="relative w-full max-w-6xl mx-auto">
        <Swiper
          // 3. Add Swiper modules
          modules={[EffectFade, Autoplay, Pagination]}
          // 4. Set the effect to "fade" for a smooth transition
          effect="fade"
          fadeEffect={{ crossFade: true }}
          loop={validSlides.length > 1}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          onSwiper={setSwiperInstance}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          className="rounded-3xl overflow-hidden"
        >
          {validSlides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div
                className="flex h-[clamp(100px,30vh,200px)] items-center justify-center bg-cover bg-center backdrop-blur-sm bg-black/40"
                style={{ backgroundImage: `url(${Carousel1})` }}
              >
                <div className="flex flex-col items-center justify-center h-full text-center">
                  {slide.title && <h2 className="text-white lg:text-4xl sm:text-xl mb-4">{slide.title}</h2>}
                  {slide.image && (
                  <img
                      className={`w-auto ${slide.heightMobile || 'h-16'} ${slide.heightDesktop || 'lg:h-24'} object-contain`}
                    src={slide.image}
                      alt={slide.alt || slide.title || 'Carousel image'}
                  />
                  )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Pagination Indicators */}
        {validSlides.length > 1 && (
        <div className="absolute left-[20px] top-1/2 z-10 flex -translate-y-1/2 flex-col">
            {validSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => handlePaginationClick(index)}
              className={`w-[10px] h-[10px] rounded-full mb-2 cursor-pointer border-none transition-colors duration-1000 ${activeIndex === index ? 'bg-white' : 'bg-white/50 hover:bg-white/75'}`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
        )}
      </div>
    </div>
  );
};
export default CarouselComponent;